const TEXT_INPUT_SELECTOR = 'input:not([type=checkbox]):not([type=radio]):not([type=button]):not([type=submit]):not([type=file]):not([type=range]):not([type=color]), textarea, select, [contenteditable="true"]';
const KEYBOARD_OPEN_CLASS = 'keyboard-open';

function isTextField(el: EventTarget | null): el is HTMLElement {
    return el instanceof HTMLElement && el.matches(TEXT_INPUT_SELECTOR);
}

function isOutOfVisibleArea(el: HTMLElement) {
    const vv = window.visualViewport;
    const rect = el.getBoundingClientRect();
    const top = vv ? vv.offsetTop : 0;
    const bottom = vv ? vv.offsetTop + vv.height : window.innerHeight;
    return rect.top < top + 8 || rect.bottom > bottom - 8;
}

function revealField(el: HTMLElement) {
    if (document.activeElement !== el || !isOutOfVisibleArea(el)) return;
    el.scrollIntoView({ block: 'center', inline: 'nearest', behavior: 'smooth' });
}

/** Keeps focused form fields visible above the on-screen keyboard on touch devices. */
export function initKeyboardAwareInputs() {
    if (typeof window === 'undefined' || !window.matchMedia('(pointer: coarse)').matches) return;

    const root = document.documentElement;
    const vv = window.visualViewport;
    const baseHeight = { value: window.innerHeight };

    const updateKeyboardState = () => {
        const height = vv ? vv.height : window.innerHeight;
        if (!isTextField(document.activeElement)) baseHeight.value = Math.max(baseHeight.value, window.innerHeight);
        const open = isTextField(document.activeElement) && height < baseHeight.value * 0.8;
        root.classList.toggle(KEYBOARD_OPEN_CLASS, open);
        if (open && isTextField(document.activeElement)) revealField(document.activeElement);
    };

    document.addEventListener('focusin', (e) => {
        if (!isTextField(e.target)) return;
        const el = e.target;
        root.classList.add(KEYBOARD_OPEN_CLASS);
        window.setTimeout(() => revealField(el), 350);
    });

    document.addEventListener('focusout', () => {
        window.setTimeout(() => {
            if (!isTextField(document.activeElement)) root.classList.remove(KEYBOARD_OPEN_CLASS);
        }, 100);
    });

    vv?.addEventListener('resize', updateKeyboardState);
    window.addEventListener('orientationchange', () => { baseHeight.value = 0; });
}
